export default function LogIn() {
  return <h1>Login</h1>;
}
